module.exports = __webpack_public_path__ + "img/danabijak.c0afb203.svg";